<template>
    <md-dialog :md-active.sync="openDialog"
               class="modal-dialog sign-up email-preview">
        <md-dialog-content style="padding: 0;">
        <!--div class="modal-content"-->
            <div class="modal-body" style="margin-bottom: 82px;">
                <div class="row">
                    <div class="col-12 text-right" style="cursor: pointer" v-on:click="openDialog = false">
                        <close-icon class="close-btn" v-on:click="openDialog = false"
                                    width="15" height="15"></close-icon>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 text-center">
                        <svg width="227" height="113" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        	<defs><path id="a" d="M138 9.525L0 9.742 9.665.413 128.56.196z"/>
                        	<path d="M17.933 2.614C17.933 3.93 13.95 5 9.036 5 4.12 5 .138 3.931.138 2.614.138 1.296 4.12.227 9.036.227" id="c"/>
                        	<path id="e" d="M0 112h171V0H0z"/></defs>
                        	<g fill="none" fill-rule="evenodd"><g transform="translate(27 1)"><g transform="translate(0 97)">
                        	<mask id="b" fill="#fff"><use xlink:href="#a"/></mask>
                        	<path fill="#E9E9E9" mask="url(#b)" d="M138 9.525L0 9.742 9.665.413 128.56.196z"/></g>
                        	<path d="M11 72.028v23.887L3 106V76.805s8-5.232 8-4.777" fill="#F5C900"/>
                        	<path d="M11 72.028v23.887L3 106V76.805s8-5.232 8-4.777" fill="#F0894F"/>
                        	<path d="M11 73.022L10.199 73C8.174 74.066 3 77.383 3 77.383V106l.576-.713C4.522 100.326 7.07 89.463 11 81.941v-8.92z" fill="#FFB100"/>
                        	<path d="M128 72.026v24.021l8 9.953V77.19s-8-5.614-8-5.164" fill="#F5C900"/><path d="M128 72.026v24.021l8 9.953V77.19s-8-5.614-8-5.164" fill="#F0894F"/>
                        	<path d="M128 81.507c1.266 3.175 5.775 14.864 6.946 23.144L136 106V76.372s-.192-.14-.518-.372L128 80.482v1.025z" fill="#FFB100"/><path fill="#F5C900" d="M0 78l9.937-6H128.44L138 78H.15"/>
                        	<path fill="#F0894F" d="M0 78l9.937-6H128.44L138 78H.15"/><path fill="#FFE848" d="M0 77v29h2.71V81.52h132.58V106H138V77z"/>
                        	<path fill="#F3A93B" d="M8 73.227h122l-.82-.454H8.852zM133 75.227l-.823-.454H4.855L4 75.227z"/>
                        	<g transform="translate(144 107)"><mask id="d" fill="#fff"><use xlink:href="#c"/></mask>
                        	<path d="M17.933 2.614C17.933 3.93 13.95 5 9.036 5 4.12 5 .138 3.931.138 2.614.138 1.296 4.12.227 9.036.227c4.913 0 8.897 1.069 8.897 2.387" fill="#E9E9E9" mask="url(#d)"/></g>
                        	<mask id="f" fill="#fff"><use xlink:href="#e"/></mask><path fill="#F0894F" mask="url(#f)" d="M152 109h3V34h-3z"/>
                        	<path fill="#E9693E" mask="url(#f)" d="M152 37h3v-3h-3z"/><path fill="#FFB100" mask="url(#f)" d="M154 109h1V34h-1z"/>
                        	<path d="M171 17.5c0 9.665-7.835 17.5-17.5 17.5S136 27.165 136 17.5 143.835 0 153.5 0 171 7.835 171 17.5" fill="#345CD7" mask="url(#f)"/>
                        	<path d="M170 17.5c0 9.113-7.387 16.5-16.5 16.5S137 26.613 137 17.5 144.387 1 153.5 1 170 8.387 170 17.5" fill="#FFF" mask="url(#f)"/>
                        	<path d="M169 17.5c0 8.56-6.94 15.5-15.5 15.5-8.56 0-15.5-6.94-15.5-15.5C138 8.94 144.94 2 153.5 2c8.56 0 15.5 6.94 15.5 15.5" fill="#345CD7" mask="url(#f)"/></g>
                        	<path d="M189.538 11.92a.43.43 0 0 0-.309-.132h-1.396v-1.381a.444.444 0 0 0-.436-.452h-.46c-3.279 0-5.2.492-6.438 1.683-1.239-1.19-3.16-1.683-6.438-1.683h-.458a.444.444 0 0 0-.436.452v1.381h-1.397a.424.424 0 0 0-.31.132.462.462 0 0 0-.127.32l.006 11.93c0 .25.196.451.437.451h.546c5.874 0 7.123 1.511 7.247 1.67a.435.435 0 0 0 .338.164h1.185a.435.435 0 0 0 .339-.165c.123-.158 1.38-1.669 7.253-1.669h.546a.444.444 0 0 0 .437-.451V12.24a.466.466 0 0 0-.13-.32zM172.25 23.705v-11h.917v11c-.165-.004-.47-.004-.917 0zm1.833.165V10.87c3.19 0 4.93.455 5.98 1.591l-.021 13.076c-.578-.55-1.97-1.476-5.959-1.668zm6.854 1.65V12.462c1.05-1.136 2.79-1.59 5.98-1.59v12.833c-3.99.192-5.402 1.265-5.98 1.815zm7.813-1.815a34.92 34.92 0 0 0-.917 0v-11h.917v11z" fill="#FFF"/><path d="M24.177 42.743C21.87 42.743 20 40.86 20 38.538s1.87-4.205 4.177-4.205c2.307 0 4.177 1.883 4.177 4.205s-1.87 4.205-4.177 4.205zm0-1.53a2.667 2.667 0 0 0 2.658-2.675 2.667 2.667 0 0 0-2.658-2.676 2.667 2.667 0 0 0-2.658 2.676 2.667 2.667 0 0 0 2.658 2.676zM49.578 19.41c-2.307 0-4.177-1.883-4.177-4.205S47.271 11 49.578 11c2.307 0 4.177 1.883 4.177 4.205s-1.87 4.205-4.177 4.205zm0-1.53a2.667 2.667 0 0 0 2.658-2.675 2.667 2.667 0 0 0-2.658-2.676 2.667 2.667 0 0 0-2.658 2.676 2.667 2.667 0 0 0 2.658 2.676zM128.177 8.41C125.87 8.41 124 6.527 124 4.205S125.87 0 128.177 0c2.307 0 4.177 1.883 4.177 4.205s-1.87 4.205-4.177 4.205zm0-1.53a2.667 2.667 0 0 0 2.658-2.675 2.667 2.667 0 0 0-2.658-2.676 2.667 2.667 0 0 0-2.658 2.676 2.667 2.667 0 0 0 2.658 2.676zM208.177 83.243c-2.307 0-4.177-1.883-4.177-4.205s1.87-4.205 4.177-4.205c2.307 0 4.177 1.883 4.177 4.205s-1.87 4.205-4.177 4.205zm0-1.53a2.667 2.667 0 0 0 2.658-2.675 2.667 2.667 0 0 0-2.658-2.676 2.667 2.667 0 0 0-2.658 2.676 2.667 2.667 0 0 0 2.658 2.676z" fill="#F3A93C" fill-rule="nonzero"/><g stroke="#00C59D" stroke-linecap="round" stroke-linejoin="bevel" stroke-width="2"><path d="M6.472 73.832l.1 3.351M5.11 78.913l-3.586.024M6.597 80.818l-.025 3.353M12.28 78.867l-3.586.023"/></g><g stroke="#00C59D" stroke-linecap="round" stroke-linejoin="bevel" stroke-width="2"><path d="M86.472 15.832l.1 3.351M85.11 20.913l-3.586.024M86.597 22.818l-.025 3.353M92.28 20.867l-3.586.023"/></g><g stroke="#00C59D" stroke-linecap="round" stroke-linejoin="bevel" stroke-width="2"><path d="M219.59 21.165l.1 3.351M218.227 26.247l-3.586.023M219.714 28.152l-.025 3.352M225.397 26.2l-3.585.023"/>
                        	</g></g>
                        </svg>
                        <h3 class="mt-5">
                            {{t('Do you want to be')}}<br>
                            {{t('added to the waitlist?')}}</h3>

                        <div v-if="!message" class="mt-4 text-center">
                            <p class="mx-0 my-0">
                              {{t('If you add yourself to the waitlist (')}} + (seatSelected ? seatSelected.name : '') + {{t('), we will contact you via email if a space becomes available.')}}
                            </p>
                        </div>
                        <div v-else v-html="message" class="mt-4 text-center fr-view"></div>
                    </div>
                </div>
            </div>
            <div class="modal-footer d-flex justify-content-between" style="background-color: var(--md-theme-default-background,#fff) !important;">
                <button v-on:click="openDialog = false" class="btn btn-outline-primary cancel">{{t('Cancel')}}</button>
                <button v-on:click="$parent.addToWaitList(idCourse); openDialog = false" class="btn btn-primary pull-right">{{t('Yes, add me to the waitlist')}}</button>
            </div>
        <!--/div-->
        </md-dialog-content>
    </md-dialog>
</template>

<script>
import API from '@/api/index';
//import SessionManageMixin from '@/mixins/SessionManageMixin';
import CloseIcon from '@/components/Icons/CloseIcon';

export default {
    name: "WaitListModal",
    //mixins: [SessionManageMixin],
    props: {
        value: {
            type: Boolean,
        },
        message: {
            type: String,
            default() {
                return '';
            }
        },
        idCourse: {
            type: Number
        },
        seatSelected: {
            type: Object       
        },       
    },
    data() {
        return {
            openDialog: false
        }
    },
    components: {
        CloseIcon
    },
    watch: {
        value(val) {
            this.openDialog = true;
        },
        /**openDialog(val) {
            if (!val) {
                // this.$emit('refresh');
            }
            this.$emit('input', val);
        },**/
        "$parent.openWaitListModal"(val) {
            if(!val) {
                this.$emit('refresh');
            }
        },
    },
    methods:{
        async removeFromWaitlist(){
    	
    	 	let loader = this.$loading.show();
            console.log("Este es el asiento seleccionado: ", this.seatSelected);
            const apiResponse = await API.main.addToWaitList(this.idCourse, this.seatSelected.id_course_seat_type, this.seatSelected.name);
			this.$emit('refresh');
            this.waitlistMessage = apiResponse.data.message;
            this.openDialog =  false;

            loader.hide();
    	
    		console.log(this.idCourse);
    	
    	}
    }
}
</script>

<style scoped>
    .btn-default.blue,
    .btn-default.blue:hover {
        width: 250px;
        height: 35px;
        color: white !important;
        text-decoration: none;
        padding-top: 8px;
        font-size: 18px;
        line-height: 22px;
        font-family: "Source Sans Pro";
    }

    .btn-outline-primary {
    color: #383838;
    background-color: #ffffff;
    background-image: none;
    border-color: #256AB3;
    }
    .btn-outline-primary:hover {
        background-color: #D3E1EF;   
    }

    h3 {
        color: #383838;
        font-family: "Source Sans Pro";
        font-size: 40px;
        line-height: 46px;
        text-align: center;
    }

    p {
        color: #383838;
        font-family: "Source Sans Pro";
        font-size: 18px;
        line-height: 22px;
        text-align: center;
    }
</style>